import React, { FC, useState } from 'react'
import { TrophyMemoryDto } from '~/modules/Trophies/Infrastructure/TrophyDetailComponentDto'
import styles from './TrophyMemoryCard.module.scss'
import { useTranslation } from 'next-i18next'
import { TrophyMemoryLightbox } from '~/modules/TrophyMemories/Infrastructure/Components/TrophyMemoryLightbox'

interface Props {
  memoryCardDto: TrophyMemoryDto
  appearance?: 'default' | 'market'
}

export const TrophyMemoryCard: FC<Props> = ({ memoryCardDto, appearance = 'default' }) => {
  const { t } = useTranslation('trophy_memories')
  const [active, setActive] = useState<boolean>(() => false)

  return (
    <section
      className={ `
        ${styles.trophyMemoryCard__container}
        ${appearance === 'market' ? styles.trophyMemoryCard__container__market : ''}
      ` }
      onClick={ () => {
        setActive(!active)
      } }
    >
      <div
        className={ `
          ${styles.trophyMemoryCard__imageWrapper}
          ${appearance === 'market' ? styles.trophyMemoryCard__imageWrapper__market : ''}
        ` }
      >
        <img
          className={ styles.trophyMemoryCard__media }
          src={ memoryCardDto.thumbnailUrl }
          alt={ t('memory_thumbnail_alt') }
        />
      </div>
      <div
        className={ `
          ${styles.trophyMemoryCard__data}
          ${appearance === 'market' ? styles.trophyMemoryCard__data__market : ''}
        ` }
      >
        <p
          className={ `
            ${styles.trophyMemoryCard__mediaType}
            ${appearance === 'market' ? styles.trophyMemoryCard__mediaType__market : ''}
          ` }
        >
          { memoryCardDto.type }
        </p>
        <p
          className={ `
            ${styles.trophyMemoryCard__date}
            ${appearance === 'market' ? styles.trophyMemoryCard__date__market : ''}
          ` }
        >
          { t('created_at', { date: memoryCardDto.createdAt }) }
        </p>
      </div>
      <TrophyMemoryLightbox
        memory={ memoryCardDto }
        active={ active }
        setActive={ setActive }
        appearance={ appearance }
      />
    </section>
  )
}
